import type { V4HSiteId } from "@/data/common/ids";
import type { MaybeRefOrGetter } from "vue";

const mutation = {
  api: "site-programming-range",
  type: "mutation",
} as const;

export const SiteProgrammingRangeMutationKeys = {
  create: (siteId: MaybeRefOrGetter<V4HSiteId>) =>
    [mutation, { action: "create-site-programming-range", siteId }] as const,
  update: () => [mutation, { action: "update-site-programming-range" }] as const,
  delete: () => [mutation, { action: "delete-site-programming-range" }] as const,
};
